import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';
import { NumbersOnlyDirective } from '../../directives/numbers-only.directive';

@Component({
    selector: 'positive-integers-input',
    template: `<input
		matInput
		[formControl]="formControl"
		[formlyAttributes]="field"
		[type]="props?.type"
		pattern="[0-9]*"
		numbersOnly
		[allowDecimals]="false"
		[maxlength]="props.maxLength"
		[readonly]="props.readonly"
	/>`,
    standalone: true,
    imports: [
        MatInputModule,
        FormsModule,
        NumbersOnlyDirective,
        ReactiveFormsModule,
        FormlyModule,
    ],
})
export class FormlyPositiveIntegersInputComponent extends FieldType<FormlyFieldConfig> {}
